import { create } from 'zustand';

interface NotificationPrefsState {
  enabled: boolean; // user toggle
}

interface NotificationActions {
  setEnabled: (enabled: boolean) => void;
}

type NotificationStore = NotificationPrefsState & NotificationActions;

export const useNotificationStore = create<NotificationStore>((set) => ({
  enabled: true,
  setEnabled: (enabled: boolean) => set({ enabled })
}));
